const DEFAULT_PREFIXES = ['', 'VITE_', 'REACT_APP_', 'NEXT_PUBLIC_'];
/**
 * Resolves a value from multiple possible environment sources (Node, Vite, CRA, Next, window)
 * using a list of supported prefixes.
 */
export function resolveEnvValue(key, prefixes = DEFAULT_PREFIXES) {
    for (const prefix of prefixes) {
        const envKey = prefix ? `${prefix}${key}` : key;
        if (typeof process !== 'undefined' && process?.env?.[envKey]) {
            console.log(`process.env[${envKey}]`, process.env[envKey]);
            return process.env[envKey];
        }
        if (typeof import.meta !== 'undefined' && import.meta?.env?.[envKey]) {
            console.log(`import.meta.env[${envKey}]`, import.meta.env[envKey]);
            return import.meta.env[envKey];
        }
        if (typeof window !== 'undefined' && window?.__TAGADA_ENV__?.[envKey]) {
            console.log(`window.__TAGADA_ENV__[${envKey}]`, window.__TAGADA_ENV__[envKey]);
            return window.__TAGADA_ENV__[envKey];
        }
    }
    return undefined;
}
